import { useLocalesStore } from "@/stores/i18n"
import { getAvailableLanguages, mapLanguageValueToKey } from "@/lang/config"

// Get current languages from organization - getAvailableLanguages automatically gets organization from store
const current_language = [...getAvailableLanguages()] as string[]

const getTranslatedObject = (object:object, name_var:string) => {
    const localeStore = useLocalesStore()
    // Convert language value (e.g., "ca") to key (e.g., "lang1") for variable names
    const languageKey = mapLanguageValueToKey(localeStore.locale) || localeStore.locale
    const var_name = name_var + '_' + languageKey
    return object[var_name]
}

const translate = (object:object, name_vars:string[]) => {
    const localeStore = useLocalesStore()
    // Convert language value (e.g., "ca") to key (e.g., "lang1") for variable names
    const languageKey = mapLanguageValueToKey(localeStore.locale) || localeStore.locale
    name_vars.forEach(nv => {
        const var_name = nv + '_' + languageKey;
        object[nv] = object[var_name];
    });

    return object
}

const translateAll = (object:object[], name_vars:string[]) => {    
    object.forEach(o => {
        translate(o, name_vars)
    });

    return object
}

const translateSingleString = (object:object, name_var:string) => {
    const localeStore = useLocalesStore()
    // Convert language value (e.g., "ca") to key (e.g., "lang1") for variable names
    const languageKey = mapLanguageValueToKey(localeStore.locale) || localeStore.locale
    const var_name = name_var + '_' + languageKey    
    object[name_var] = object[var_name];

    return object[name_var]
}

export { translate, translateAll, translateSingleString, getTranslatedObject, current_language };
